// extracted by mini-css-extract-plugin
export default {"text":"ReschedulingPeriodOverdueError-module_text_e988dd","container":"ReschedulingPeriodOverdueError-module_container_e0c06c"};